module.exports = __webpack_public_path__ + "static/media/hero-video.5f9aae9c.mp4";